<div class="blinking modal-wait modal-body">
  <br />
  Please wait<br />
  <br />
</div>
  